<script>
  import SubNav from './SubNav'
  import { messageSuccess } from "@utils/message";
  import chroma from "chroma-js";
    import { authComputed } from '@store/helpers'
  // import { BRAND_MENU, SOLUTION_MENU, PRODUCT_MENU } from "@src/config/fake-data";
  // import { authComputed, globalComputed, optionComputed } from '@store/helpers'

  export default {
    components: {
      SubNav,
      MenuToggle: () => import("./MenuToggle"),
    },
    data() {
      return {
        menuList: [
          {
            text: '關於',
            to: {
              name: 'about-list'
            }
          },
          {
            text: '新訊',
            type: 'nav',
            to: {
              name: 'news-list'
            },
            children: [
              {
                text: '新訊',
                to: {
                  name: 'news-list',
                  params: {
                    categoryAlias: 'bulletin'
                  }
                }
              },
              {
                text: '活動',
                to: {
                  name: 'news-list',
                  params: {
                    categoryAlias: 'event'
                  }
                }
              },
            ]
          },
          {
            text: '解決方案',
            to: {
              name: 'solution-list'
            }
          },
          {
            text: '微軟原⽣解決⽅案',
            to: {
              name: 'resource-list'
            }
          },

        ],
        showMobileMenu: false,
      }
    },
    computed: {
      ...authComputed,
      // ...globalComputed,
      // ...optionComputed,
      diaplayMenuLength() {
        return this.menuList.filter(menuItem => {
          return this.$root.IS_DEVELOPMENT || (!this.$root.IS_DEVELOPMENT && !menuItem.isDevelopmentPage)
        }).length;
      },
      redirectUrl() {
        return window.location.origin
      }
    },
    mounted() {
      this.setTriangleColor()
    },
    methods: {
      setTriangleColor() {
        const f = chroma.scale(['0078D4', 'ABCD03' ]);
        const list = this.$refs.navListItem
        list.forEach((item, i) => {
          const linkTriangle = item.querySelectorAll('.navList__link .navList__linkTriangle')
          linkTriangle[0].style.background = f((item.offsetLeft + item.offsetWidth /2) / window.innerWidth).toString();
        })
      },

    }
  }
</script>
<template>
  <header :class="[$style.header]">
    <div class="header__inner">
      <div class="container--menu">
        <div class="header__headerList d-lg-flex d-none">
          <!--Header Left-->
          <div class="header__headerLeft">
            <router-link :to="{ name: 'home' }">
              <img 
                src="@assets/images/logo/zerone@2.png" 
                alt="ZeroneLogo"
                class="header__logo"
              >
              <img 
                src="@assets/images/logo/microsoft@2.png" 
                alt="MicrosoftLogo"
                class="header__logo MicrosoftLogo"
              >
            </router-link>
          </div>
          <!--Header Cetner-->
          <div class="header__headerCenter">
            <ul :class="$style.navList">
              <template v-for="(menuItem, $index) in menuList">
                <li
                  ref="navListItem"
                  :key="$index"
                  class="navList__item"
                  :class="{ 'hasSubNav': menuItem.children && menuItem.children.length > 0 }"
                >
                  <router-link
                    class="navList__link"
                    :to="menuItem.to"
                    
                  >
                    {{ menuItem.text }}
                    <div 
                      class="navList__linkTriangle"
                    ></div>
                  </router-link>
                  
                  <SubNav
                    v-if="menuItem.children && menuItem.children.length > 0"
                    :list="menuItem.children"
                    class="navList__subNav"
                  />
                </li>
              </template>
            </ul>
          </div>
          <!--Header Right-->
          <div class="header__headerRight">
            <div :class="$style.toolList">
              <div class="toolList__item">
                <BaseButton
                  class="isStyleDark isOutline isCircle isSmaller toolList__tool isContact"
                  :href="$globalContactLink"
                >
                  <i class="fal fa-comment-alt"></i>
                </BaseButton>
              </div>
              <div class="toolList__item">
                <BaseButton
                  v-if="loggedIn"
                  class="isStylePrimary isOutline isCircle isSmaller toolList__tool isMember"
                  :href="`/member`"
                  :target="'_self'"
                >
                  <i class="icomoon icon-user"></i>
                </BaseButton>
                <BaseButton
                  v-else
                  class="isStylePrimary isCircle isSmaller toolList__tool isLogin"
                  :href="`/login`"
                  :target="'_self'"
                >
                  <i class="icomoon icon-user"></i>
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <div class="header__headerList header__mobile d-lg-none">
          <div class="header__mobileHeaderLeft">
            <i v-if="showMobileMenu" class="fal fa-fw fa-times header__hambuger" @click="showMobileMenu = false"></i>
            <i v-else class="fal fa-fw fa-bars header__hambuger" @click="showMobileMenu = true"></i>
          </div>
          <!--Header Cetner-->
          <div class="header__mobileHeaderCenter">
            <router-link :to="{ name: 'home' }">
              <img 
                src="@assets/images/logo/zerone@2.png" 
                alt="ZeroneLogo"
                class="header__logo"
              >
              <img 
                src="@assets/images/logo/microsoft@2.png" 
                alt="MicrosoftLogo"
                class="header__logo MicrosoftLogo"
              >
            </router-link>
          </div>
          <!--Header Right-->
          <div class="header__mobileHeaderRight">
            <div :class="$style.toolList">
              <!-- <div class="toolList__item">
                <BaseButton
                  class="isStyleDark isOutline isCircle isSmaller toolList__tool isContact"
                  :href="$globalContactLink"
                >
                  <i class="fal fa-comment-alt"></i>
                </BaseButton>
              </div> -->
              <div class="toolList__item">
                <BaseButton
                  class="isStylePrimary isCircle isSmaller toolList__tool isLogin"
                  href="https://zerone2021.dingsomething.com/login"
                >
                  <i class="icomoon icon-user"></i>
                </BaseButton>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- mobile menu -->
    <div v-if="showMobileMenu" :class="$style.mobileNav" class="d-lg-none">
      <div :class="$style.navList">
        <template v-for="(menuItem, $index) in menuList">
          <MenuToggle :key="$index" :item="menuItem" />
          
        </template>
      </div>
      <div class="w-100 text-center mt-5 px-3">
        <BaseButton
          :href="$globalContactLink"
          class="isStylePrimary isRadius isCol4"
        >
          聯繫我們
        </BaseButton>
      </div>
      
    </div>
  </header>
</template>
<style lang="scss" module>
  .header {
    position: relative;
    z-index: $z-index-header;
    height: 71px;
    @include max-lg {
      height: 48px;
    }
    :global {
      .header {
        &__logo{
          top: -3px;
          height: 24px;
          position: relative;
          &.MicrosoftLogo {
            height: 34px;
          }
          @include max-lg {
            height: auto;
            max-width: 27%;
          }
          @include max-2sm {
            max-width: 40%;
          }
          &:not(:last-child) {
            margin-right: 1.5rem;
            border-right: 2px solid black;
            padding-right: 24px;
            @include max-lg {
              padding-right: 1rem;
              margin-right: 1rem;
            }
          }
        }
        &__inner{
          position: fixed;
          top: 0;
          width: 100%;
          background: rgba($color: #ffffff, $alpha: 0.95);
          backdrop-filter: blur(3px);
          box-shadow: 0 10px 20px #25381019;
          height: 71px;
          @include max-lg {
            height: 48px;
          }
          &::before {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            height: 6px;
            content: '';
            background: $color-primary-gradient;
            @include max-lg {
              height: 5px;
            }
          }
        }
        &__headerList {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        &__headerLeft {
          position: relative;
          // padding: 1.27rem 0;
        }
        &__headerCenter {
          z-index: 1;
        }
        &__headerRight {
          z-index: 1;
        }


        // mobile
        &__mobile {
          padding: 0.7rem 0;
        }
        &__hambuger {
          font-size: 1.5rem;
          color: $color-primary;
        }
        &__mobileHeaderCenter {
          text-align: center;
        }
        &__mobileHeaderRight {

        }
      }
    }
  }
  .toolList {
    display: flex;
    align-items: center;
    min-width: 40px;
    @include max-lg {
      min-width: 30px;
      justify-content: flex-end;
    }
    :global {
      .toolList {
        &__item {
          padding:  0 0.5rem;
          &:last-child {
            padding-right: 0;
          }
        }
        &__tool {
          @include max-lg {
            &.isCircle.isSmaller {
              height: 30px;
              width: 30px;
            }
            font-size: 0.875rem;
          }
          @include max-md {
            &.isCircle.isSmaller {
              height: 25px;
              width: 25px;
            }
          }
          &.isCircle {
            padding: 0 0 0 2px;
          }
          &.isContact {
            &:hover {
              background: $color-primary !important;
            }
          }
        }
      }
    }
  }
  .navList {
    @include list-unstyled;
    display: flex;
    align-items: center;
    // margin-right: -2.5rem;
    :global {
      .navList {
        &__item {
          z-index: 0;
          padding-left: 0;
          &:hover {
            .navList {
              &__subNav {
                pointer-events: auto;
                opacity: 1;
              }
              &__link {
                color: $color-gray-6;
                font-weight: 500;
                text-decoration: none;
                &::before {
                  top: 2px;
                }
              }
            }
          }

          &.hasSubNav {
            position: relative;
          }
        }
        &__link {
          position: relative;
          top: 2px;
          display: inline-block;
          height: 65px;
          padding: 1.3rem 2.5rem;
          overflow: hidden;
          color: #262626;
          @include max-xl {
            padding: 1.3rem 1.5rem;
          }
          @include max-lg {
            top: 1px;
          }
          &:hover {
            .navList__linkTriangle {
              bottom: 0px;
            }
          }
          &.router-link-active {
            color: $color-gray-6;
            font-weight: 500;
            // &::before {
            //   top: 0 !important
            // }
            .navList__linkTriangle {
              bottom: 0px;
            }
          }
        }
        &__linkTriangle {
          width: 18px;
          height: 9px;
          position: absolute;
          bottom: -15px;
          left: 50%;
          clip-path: polygon(50% 0, 0% 100%, 100% 100%);
          // background: transparent linear-gradient(180deg, #80CC28 0%, #00ADEF 100%) 0% 0% no-repeat padding-box;
          transform: translateX(-50%);
          transition: .3s;
        }
      }
    }
  }
  .mobileNav {
    width: 100%;
    height: calc(var(--vh, 1vh)*100 - 48px);
    background: #fff;
    top: 52px;
    position: fixed;
    @include max-md {
      top: 49px;
    }
    .navList {
      display: block;
    }
  }
</style>
